import {inject, provideAppInitializer} from '@angular/core';
import {TrackingService} from '@core/services/tracking.service';
import {CheckWebpSupportService} from '../../../../libs/core/services/check-webp-support/chek-webp-support.service';

function appInitializer(
  trackingService: TrackingService,
  checkWebpSupportService: CheckWebpSupportService,
): () => void {
  return () => {
    trackingService.removeCookiesBeforeConsent();
    trackingService.initGoogleAds();
    checkWebpSupportService.init();
  };
}

export const AppInitializer = provideAppInitializer(() => {
  const initializerFn = appInitializer(
    inject(TrackingService),
    inject(CheckWebpSupportService),
  );
  return initializerFn();
});
